import React from 'react';
import { Breadcrumb } from '../../shared/web/layout/Breadcrumbs';
import { SettingsBreadcrumbs } from '../settingsModule';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import ClientPortalConfigurationForm from './Domain/ClientPortalConfigurationForm';
import { Separator } from 'features/nekst-widgets';
import { ClientPortalBrandingToggleWrapper } from 'feature-toggle';
import ClientPortalBrandingSection from './Branding/ClientPortalBrandingSection';
import { Header3 } from "ui-builder";

export default function ClientPortalDomainSettingsPage() {
  return (
    <>
      <SettingsBreadcrumbs>
        <Breadcrumb text="Client Portal Branding" />
      </SettingsBreadcrumbs>
      <InnerBlock title="Client Portal Branding">
        <Header3>Subdomain</Header3>
        <ClientPortalConfigurationForm />
        <ClientPortalBrandingToggleWrapper>
          <Separator marginSize="big" />
          <Header3>Logo and colors</Header3>
          <ClientPortalBrandingSection />
        </ClientPortalBrandingToggleWrapper>
      </InnerBlock>
    </>
  );
}
